import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=6b2da31f&scoped=true&"
import script from "./Images.vue?vue&type=script&lang=js&"
export * from "./Images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2da31f",
  null
  
)

export default component.exports